// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-check-box-container{display:flex;align-items:center;gap:.5rem;margin:.5rem 0}.imgg{width:12px;height:12px}@media screen and (max-width:360px){.imgg{width:8px;height:10px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
